import React from 'react';
import './deleteACcountStepsStyles.css';
import { Fieldset } from 'primereact/fieldset';

const imgLogo = require('../../assets/navBar-logo.png');
const step1 = require('../../assets/deleteSteps/step-1.png');
const step2 = require('../../assets/deleteSteps/step-2.png');
const step3 = require('../../assets/deleteSteps/step-3.png');

export const DeleteAccountSteps = () => {
  return (
    <div>
      <header className="header-delete">
        <div className="navbar-header expand-logo">
          <a className="navbar-brand d-block d-lg-block p-0" href="/">
            <span className="logo-text">
              <img
                src={imgLogo}
                className="light-logo"
                alt="homepage"
                height="50px"
              />
            </span>
          </a>
        </div>
      </header>
      <div className="row justify-content-center container-delete">
        <div className="col-10 col-md-12 text-center my-4">
          <h1 className="text-danger">
            Deleting Account Flow for Android and IOS
          </h1>
          <p>Last Updated April 25, 2024</p>
          <p className="h3">
            <strong>
              The following steps take place when the user deletes an account:
            </strong>
          </p>
          <p className="h5">
            A user can delete an account from the app at any point of time.
          </p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 text-center my-2">
          <h3 className="px-5 pb-3 pt-2">
            <strong>Step 1:</strong> Open the nControl app and tap the menu icon
          </h3>
          <img src={step1} alt="" width="200" />
        </div>
        <div className="col-12 col-md-6 col-lg-4 text-center my-2">
          <h3 className="px-5 pb-3 pt-2">
            <strong>Step 2:</strong> Find and click on DELETE ACCOUNT button
          </h3>
          <img src={step2} alt="" width="200" />
        </div>
        <div className="col-12 col-md-6 col-lg-4 text-center my-2">
          <h3 className="px-5 pb-3 pt-2">
            <strong>Step 3:</strong> Click on the YES button to confirm
          </h3>
          <img src={step3} alt="" width="200" />
        </div>
        <div className="col-11 col-md-10 mt-5">
          <div className="card flex justify-content-center p-0">
            <Fieldset legend="Without nControl App">
              <p className="m-0 h6">
                To delete an account without using the application, send an
                email to
                <a href="mailto:cardinal@cardet.com"> cardinal@cardet.com</a>.
                You need to send the email from the same email address you
                registered in the system. We will be happy to assist you in the
                process.
              </p>
            </Fieldset>
          </div>
        </div>
      </div>
    </div>
  );
};
